import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject} from "rxjs";
import { environment } from "src/environments/environment";
import { Campaigns } from "../interfaces/CampaignsData";

@Injectable({
    providedIn: 'root'
  })

export class MisCampaniasService{
    private baseApi = environment.baseApi + '/campanias';

    private tokenSubject = new Subject<string>();

    constructor(private http: HttpClient){}

    setToken(token: string): void {
        this.tokenSubject.next(token);
      }
    
      getToken(): Observable<string> {
        return this.tokenSubject.asObservable();
      }

    getAllCampaigns(token: string): Observable<Campaigns[]> {
        return this.http.get<Campaigns[]>(`${this.baseApi}/byToken/${token}`);
    }

    getCampaignById(id: number): Observable<Campaigns> {
      return this.http.get<Campaigns>(`${this.baseApi}/byId/${id}`);
    }
}